import { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';
import { entregaService, orderService } from '../services/api';
import OrderDetail from '../components/OrderDetail';

const fmt = n => '₡' + Number(n || 0).toLocaleString('es-CR');
const fmtFecha = f => { if (!f) return '—'; const d = f.split('T')[0].split('-'); return `${parseInt(d[2])}-${parseInt(d[1])}-${d[0]}`; };
const COLOR_ESTADO = { 'Asignada':'#3b82f6', 'Entregada':'#10b981', 'No Entregada':'#ef4444' };
const METODOS = ['Efectivo', 'Tarjeta', 'Deposito', 'SINPE', 'Transferencia', 'Tasa Cero', 'Minicuotas'];
const fechaLocal = (d = new Date()) => { const y = d.getFullYear(); const m = String(d.getMonth()+1).padStart(2,'0'); const dd = String(d.getDate()).padStart(2,'0'); return `${y}-${m}-${dd}`; };

export default function Entregas() {
  const [tab, setTab] = useState('asignar');
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const puedeRevisar = [2, 3].includes(user.id); // Felix y Pablo
  const [editarPagoEnt, setEditarPagoEnt] = useState(null);
  const [disponibles, setDisponibles] = useState([]);
  const [choferes, setChoferes] = useState([]);
  const [entregas, setEntregas] = useState([]);
  const [caja, setCaja] = useState(null);
  const [loading, setLoading] = useState(true);
  const [asignando, setAsignando] = useState({});
  const [fechaCaja, setFechaCaja] = useState(fechaLocal());

  const hoy = new Date();
  const lunesSemana = new Date(hoy); lunesSemana.setDate(hoy.getDate() - ((hoy.getDay()+6)%7));
  const [desde, setDesde] = useState(fechaLocal(lunesSemana));
  const [hasta, setHasta] = useState(fechaLocal(hoy));
  const [cajaSem, setCajaSem] = useState(null);
  const [selected, setSelected] = useState(null);
  const [retiroTaller, setRetiroTaller] = useState(null); // { orderId, entregaId, total } cuando se elige Retiro en Taller
  const [buscarAsignar, setBuscarAsignar] = useState('');
  const [buscarEstado, setBuscarEstado] = useState('');
  const [buscarCaja, setBuscarCaja] = useState('');

  const cargarTodo = async () => {
    setLoading(true);
    try {
      const [d, c, e] = await Promise.all([
        entregaService.disponibles(),
        entregaService.choferes(),
        entregaService.listar(),
      ]);
      setDisponibles(d.data);
      setChoferes(c.data);
      setEntregas(e.data);
    } catch {}
    setLoading(false);
  };

  const cargarCaja = async (f) => {
    try {
      const res = await entregaService.caja(f || fechaCaja);
      setCaja(res.data);
    } catch {}
  };

  const cargarCajaSemana = async (d, h) => {
    try {
      const res = await entregaService.cajaSemana(d || desde, h || hasta);
      setCajaSem(res.data);
    } catch {}
  };

  useEffect(() => { cargarTodo(); cargarCaja(); }, []);

  const [filtroChoferCaja, setFiltroChoferCaja] = useState('');
  const revisar = async (id, valor) => {
    try {
      await entregaService.marcarRevisado(id, valor);
      cargarCaja();
    } catch (err) {
      alert(err.response?.data?.error || 'Error al marcar el visto bueno');
    }
  };

  const verOrden = async (orderId) => {
    try {
      const res = await orderService.getOne(orderId);
      setSelected(res.data);
    } catch (err) { alert('No se pudo cargar la orden'); }
  };

  const asignar = async (orderId, choferId) => {
    if (!choferId) return;
    try {
      await entregaService.asignar(orderId, choferId);
      // Si es "Retiro en Taller" (id 17), abrir modal de pago para registrar la entrega + cobro
      if (String(choferId) === '17') {
        const orden = disponibles.find(o => o.id === orderId);
        const total = orden ? (Number(orden.amount) + Number(orden.shipping || 0)) : 0;
        // Recargar para obtener la entrega recién creada
        const listaRes = await entregaService.listar();
        const ent = (listaRes.data || []).find(e => e.order_id === orderId && e.estado === 'Asignada');
        if (ent) {
          setRetiroTaller({ orderId, entregaId: ent.id, numero: orden?.numero, total });
        }
      }
      await cargarTodo();
    } catch (err) { alert(err.response?.data?.error || 'Error al asignar'); }
  };

  const desasignar = async (id) => {
    if (!window.confirm('¿Quitar esta asignación?')) return;
    try {
      await entregaService.desasignar(id);
      await cargarTodo();
    } catch (err) { alert(err.response?.data?.error || 'Error'); }
  };

  const reasignar = async (id, choferId) => {
    if (!choferId) return;
    try {
      await entregaService.reasignar(id, choferId);
      await cargarTodo();
    } catch (err) { alert(err.response?.data?.error || 'Error al reasignar'); }
  };

  const imprimirCaja = () => {
    if (!caja || caja.entregas.length === 0) { alert('No hay entregas para imprimir en esta fecha'); return; }
    // Respetar el filtro de chofer seleccionado en pantalla
    const entregasImp = caja.entregas.filter(e => !filtroChoferCaja || e.chofer_nombre === filtroChoferCaja);
    if (entregasImp.length === 0) { alert('No hay entregas para ese chofer en esta fecha'); return; }
    const totalDia = entregasImp.reduce((sum,e)=>sum+Number(e.total_orden),0);
    const filasOrdenes = entregasImp.map(e =>
      `<tr><td>${e.numero}</td><td>${e.cliente_nombre||''}</td><td>${e.chofer_nombre}</td><td style="text-align:right;">${fmt(e.total_orden)}</td></tr>`
    ).join('');
    // Desglose por método: calcular desde las entregas filtradas (por su método de pago)
    const filasMetodos = METODOS.map(m => {
      const t = entregasImp.filter(e => (e.metodos||'').split(' + ').includes(m)).reduce((s,e)=>s+Number(e.total_orden),0);
      if (t===0) return '';
      return `<tr><td>${m}</td><td style="text-align:right;">${fmt(t)}</td></tr>`;
    }).join('');
    const choferes2 = [...new Set(entregasImp.map(e=>e.chofer_nombre))];
    const filasChoferes = choferes2.map(ch => {
      const dc = entregasImp.filter(e=>e.chofer_nombre===ch);
      const tc = dc.reduce((s,e)=>s+Number(e.total_orden),0);
      return `<tr><td>${ch} (${dc.length} entrega${dc.length!==1?'s':''})</td><td style="text-align:right;">${fmt(tc)}</td></tr>`;
    }).join('');
    const html = `<html><head><meta charset="utf-8"><title>Caja ${fechaCaja}</title><style>
      body{font-family:Arial,sans-serif;padding:0;margin:0;color:#333;}
      h1{font-size:20px;color:#5c3d2e;margin:0 0 4px;}
      h2{font-size:14px;color:#5c3d2e;margin:18px 0 6px;border-bottom:2px solid #e0d0c0;padding-bottom:4px;}
      .sub{font-size:13px;color:#666;margin-bottom:14px;}
      table{width:100%;border-collapse:collapse;margin-bottom:8px;}
      th{background:#f5ede6;padding:7px 9px;text-align:left;font-size:12px;color:#5c3d2e;border-bottom:2px solid #e0d0c0;}
      td{padding:6px 9px;border-bottom:1px solid #f0e8e0;font-size:12px;}
      .total{font-weight:800;font-size:14px;color:#5c3d2e;}
      tr{page-break-inside:avoid;}
      @page{margin:14mm;size:A4;}
    </style></head><body>
      <div style="text-align:center;border-bottom:3px solid #5c3d2e;padding-bottom:10px;margin-bottom:14px;">
        <h1>Muebles Terrasol</h1>
        <div class="sub">Reporte de Caja — ${fmtFecha(fechaCaja + 'T00:00:00')}</div>
      </div>
      <h2>Ordenes entregadas</h2>
      <table>
        <thead><tr><th>Orden</th><th>Cliente</th><th>Chofer</th><th style="text-align:right;">Total</th></tr></thead>
        <tbody>${filasOrdenes}
          <tr class="total"><td colspan="3">TOTAL DEL DIA</td><td style="text-align:right;">${fmt(totalDia)}</td></tr>
        </tbody>
      </table>
      <h2>Desglose por metodo de pago</h2>
      <table><tbody>${filasMetodos}</tbody></table>
      <h2>Por chofer</h2>
      <table><tbody>${filasChoferes}</tbody></table>
      <div style="margin-top:30px;font-size:11px;color:#999;text-align:center;">Generado el ${new Date().toLocaleString('es-CR')}</div>
    </body></html>`;
    const win = window.open('', '_blank');
    win.document.write(html); win.document.close(); win.focus();
    setTimeout(() => { win.print(); win.close(); }, 600);
  };

  const imprimirSemana = () => {
    if (!cajaSem || cajaSem.entregas.length === 0) { alert('No hay entregas en este rango'); return; }
    const dias = [...new Set(cajaSem.entregas.map(e => e.dia.split('T')[0]))].sort();
    const totalGeneral = cajaSem.entregas.reduce((s,e)=>s+Number(e.total_orden),0);
    let bloquesDias = '';
    dias.forEach(dia => {
      const delDia = cajaSem.entregas.filter(e => e.dia.split('T')[0] === dia);
      const totalDia = delDia.reduce((s,e)=>s+Number(e.total_orden),0);
      const filas = delDia.map(e => `<tr><td>${e.numero}</td><td>${e.cliente_nombre||''}</td><td>${e.chofer_nombre}</td><td style="text-align:right;">${fmt(e.total_orden)}</td></tr>`).join('');
      bloquesDias += `<h3 style="font-size:13px;color:#5c3d2e;margin:14px 0 4px;">${fmtFecha(dia + 'T00:00:00')}</h3>
        <table><thead><tr><th>Orden</th><th>Cliente</th><th>Chofer</th><th style="text-align:right;">Total</th></tr></thead>
        <tbody>${filas}<tr style="font-weight:700;"><td colspan="3">Total del dia</td><td style="text-align:right;">${fmt(totalDia)}</td></tr></tbody></table>`;
    });
    const filasMetodos = METODOS.map(m => {
      const t = cajaSem.pagos.filter(p=>p.metodo===m).reduce((s,p)=>s+Number(p.total),0);
      if (t===0) return '';
      return `<tr><td>${m}</td><td style="text-align:right;">${fmt(t)}</td></tr>`;
    }).join('');
    const choferes2 = [...new Set(cajaSem.entregas.map(e=>e.chofer_nombre))];
    const filasChoferes = choferes2.map(ch => {
      const dc = cajaSem.entregas.filter(e=>e.chofer_nombre===ch);
      const tc = dc.reduce((s,e)=>s+Number(e.total_orden),0);
      return `<tr><td>${ch} (${dc.length})</td><td style="text-align:right;">${fmt(tc)}</td></tr>`;
    }).join('');
    const html = `<html><head><meta charset="utf-8"><title>Caja semana</title><style>
      body{font-family:Arial,sans-serif;padding:0;margin:0;color:#333;}
      h1{font-size:20px;color:#5c3d2e;margin:0 0 4px;}
      h2{font-size:14px;color:#5c3d2e;margin:18px 0 6px;border-bottom:2px solid #e0d0c0;padding-bottom:4px;}
      .sub{font-size:13px;color:#666;margin-bottom:14px;}
      table{width:100%;border-collapse:collapse;margin-bottom:6px;}
      th{background:#f5ede6;padding:6px 9px;text-align:left;font-size:12px;color:#5c3d2e;border-bottom:2px solid #e0d0c0;}
      td{padding:5px 9px;border-bottom:1px solid #f0e8e0;font-size:12px;}
      tr{page-break-inside:avoid;}
      @page{margin:14mm;size:A4;}
    </style></head><body>
      <div style="text-align:center;border-bottom:3px solid #5c3d2e;padding-bottom:10px;margin-bottom:14px;">
        <h1>Muebles Terrasol</h1>
        <div class="sub">Reporte de Caja Semanal — ${fmtFecha(desde+'T00:00:00')} al ${fmtFecha(hasta+'T00:00:00')}</div>
      </div>
      ${bloquesDias}
      <div style="background:#f5ede6;padding:10px;margin-top:10px;text-align:right;font-size:15px;font-weight:800;color:#5c3d2e;">TOTAL GENERAL: ${fmt(totalGeneral)}</div>
      <h2>Desglose por metodo de pago (toda la semana)</h2>
      <table><tbody>${filasMetodos}</tbody></table>
      <h2>Por chofer (toda la semana)</h2>
      <table><tbody>${filasChoferes}</tbody></table>
      <div style="margin-top:24px;font-size:11px;color:#999;text-align:center;">Generado el ${new Date().toLocaleString('es-CR')}</div>
    </body></html>`;
    const win = window.open('', '_blank');
    win.document.write(html); win.document.close(); win.focus();
    setTimeout(() => { win.print(); win.close(); }, 600);
  };

  const s = {
    page: { fontFamily:"'Segoe UI',sans-serif", minHeight:'100vh', background:'#f8f5f0' },
    main: { maxWidth:1100, margin:'0 auto', padding:'20px 14px' },
    card: { background:'#fff', borderRadius:10, boxShadow:'0 1px 6px rgba(0,0,0,0.09)', padding:20, marginBottom:16 },
    tab: active => ({ background:active?'#5c3d2e':'#f0ebe5', color:active?'#fff':'#5c3d2e', border:'none', padding:'10px 18px', borderRadius:8, cursor:'pointer', fontSize:14, fontWeight:600, marginRight:8, marginBottom:8 }),
    th: { background:'#f5ede6', padding:'9px 11px', textAlign:'left', fontWeight:600, color:'#5c3d2e', borderBottom:'2px solid #e0d0c0', fontSize:13 },
    td: { padding:'9px 11px', borderBottom:'1px solid #f0e8e0', fontSize:13, verticalAlign:'middle' },
    badge: e => ({ background:COLOR_ESTADO[e]||'#aaa', color:'#fff', padding:'3px 10px', borderRadius:20, fontSize:11, fontWeight:600 }),
    select: { padding:'7px 10px', border:'1px solid #ddd', borderRadius:7, fontSize:13 },
  };

  return (
    <div style={s.page}>
      <Navbar />
      <div style={s.main}>
        <h1 style={{ color:'#5c3d2e', fontSize:22, marginBottom:16 }}>🚚 Entregas</h1>

        <div style={{ marginBottom:16 }}>
          <button style={s.tab(tab==='asignar')} onClick={()=>setTab('asignar')}>📋 Asignar ({disponibles.length})</button>
          <button style={s.tab(tab==='estado')} onClick={()=>setTab('estado')}>🚚 Estado de Entregas</button>
          <button style={s.tab(tab==='caja')} onClick={()=>{setTab('caja'); cargarCaja(fechaCaja);}}>💰 Caja del Día</button>
          <button style={s.tab(tab==='semana')} onClick={()=>{setTab('semana'); cargarCajaSemana();}}>📅 Caja Semanal</button>
        </div>

        {loading && <div style={{ textAlign:'center', padding:40, color:'#aaa' }}>Cargando...</div>}

        {/* TAB ASIGNAR */}
        {!loading && tab === 'asignar' && (
          <div style={s.card}>
            <h2 style={{ fontSize:16, color:'#5c3d2e', marginTop:0 }}>Órdenes listas para asignar</h2>
            <input type="text" placeholder="🔍 Buscar por orden, cliente o dirección..." value={buscarAsignar} onChange={e => setBuscarAsignar(e.target.value)} style={{ width:'100%', padding:10, border:'1px solid #ccc', borderRadius:8, fontSize:14, marginBottom:14, boxSizing:'border-box' }} />
            {disponibles.length === 0 ? (
              <div style={{ color:'#aaa', textAlign:'center', padding:24 }}>No hay órdenes en estado "Lista" sin asignar</div>
            ) : (
              <div style={{ overflowX:'auto' }}>
                <table style={{ width:'100%', borderCollapse:'collapse' }}>
                  <thead><tr>
                    <th style={s.th}>Orden</th><th style={s.th}>Cliente</th><th style={s.th}>Artículo</th>
                    <th style={s.th}>Dirección</th><th style={s.th}>Total</th><th style={s.th}>Asignar a</th>
                  </tr></thead>
                  <tbody>
                    {disponibles.filter(o => {
                      const b = buscarAsignar.trim().toLowerCase();
                      if (!b) return true;
                      return (o.numero||'').toLowerCase().includes(b) || (o.cliente_nombre||'').toLowerCase().includes(b) || (o.address||'').toLowerCase().includes(b);
                    }).map(o => (
                      <tr key={o.id} style={{ cursor:'pointer' }} onClick={()=>verOrden(o.id)}>
                        <td style={{ ...s.td, fontWeight:600, color:'#a0522d' }}>{o.numero}</td>
                        <td style={s.td}><strong>{o.cliente_nombre}</strong><div style={{ fontSize:11, color:'#aaa' }}>{o.phone1||''}</div></td>
                        <td style={s.td}>{o.article}</td>
                        <td style={{ ...s.td, maxWidth:200 }}>{o.address||'—'}</td>
                        <td style={s.td}>{fmt(Number(o.amount)+Number(o.shipping||0))}</td>
                        <td style={s.td} onClick={ev=>ev.stopPropagation()}>
                          <select style={s.select} value={asignando[o.id]||''} onChange={e=>{ setAsignando(p=>({...p,[o.id]:e.target.value})); asignar(o.id, e.target.value); }}>
                            <option value="">— Elegir chofer —</option>
                            {choferes.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                          </select>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}

        {/* TAB ESTADO */}
        {!loading && tab === 'estado' && (
          <div style={s.card}>
            <h2 style={{ fontSize:16, color:'#5c3d2e', marginTop:0 }}>Estado de todas las entregas</h2>
            <input type="text" placeholder="🔍 Buscar por orden, cliente o chofer..." value={buscarEstado} onChange={e => setBuscarEstado(e.target.value)} style={{ width:'100%', padding:10, border:'1px solid #ccc', borderRadius:8, fontSize:14, marginBottom:14, boxSizing:'border-box' }} />
            {entregas.length === 0 ? (
              <div style={{ color:'#aaa', textAlign:'center', padding:24 }}>No hay entregas registradas</div>
            ) : (
              <div style={{ overflowX:'auto' }}>
                <table style={{ width:'100%', borderCollapse:'collapse' }}>
                  <thead><tr>
                    <th style={s.th}>Orden</th><th style={s.th}>Cliente</th><th style={s.th}>Chofer</th>
                    <th style={s.th}>Total</th><th style={s.th}>Cobrado</th><th style={s.th}>Estado</th><th style={s.th}></th>
                  </tr></thead>
                  <tbody>
                    {entregas.filter(e => {
                      const b = buscarEstado.trim().toLowerCase();
                      if (!b) return true;
                      return (e.numero||'').toLowerCase().includes(b) || (e.cliente_nombre||'').toLowerCase().includes(b) || (e.chofer_nombre||'').toLowerCase().includes(b);
                    }).map(e => (
                      <tr key={e.id} style={{ cursor:'pointer' }} onClick={()=>verOrden(e.order_id)}>
                        <td style={{ ...s.td, fontWeight:600, color:'#a0522d' }}>{e.numero}</td>
                        <td style={s.td}><strong>{e.cliente_nombre}</strong></td>
                        <td style={s.td}>{e.chofer_nombre}</td>
                        <td style={s.td}>{fmt(Number(e.amount)+Number(e.shipping||0))}</td>
                        <td style={s.td}>{e.estado==='Entregada' ? fmt(e.total_pagado) : '—'}</td>
                        <td style={s.td}>
                          <span style={s.badge(e.estado)}>{e.estado}</span>
                          {e.estado==='No Entregada' && e.motivo_no_entrega && <div style={{ fontSize:11, color:'#ef4444', marginTop:3 }}>{e.motivo_no_entrega}</div>}
                        </td>
                        <td style={s.td} onClick={ev=>ev.stopPropagation()}>
                          {e.estado !== 'Entregada' && (
                            <div style={{ display:'flex', gap:6, alignItems:'center' }}>
                              <select defaultValue="" onChange={ev=>{ reasignar(e.id, ev.target.value); ev.target.value=''; }} style={{ ...s.select, fontSize:12 }}>
                                <option value="">Reasignar a...</option>
                                {choferes.filter(c=>c.name!==e.chofer_nombre).map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                              </select>
                              {e.estado==='Asignada' && <button onClick={()=>desasignar(e.id)} style={{ background:'#fee', color:'#c00', border:'none', borderRadius:6, padding:'5px 10px', fontSize:12, cursor:'pointer' }}>Quitar</button>}
                            </div>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}

        {/* TAB CAJA DEL DÍA */}
        {!loading && tab === 'caja' && caja && (
          <div style={s.card}>
            <input type="text" placeholder="🔍 Buscar por orden o cliente..." value={buscarCaja} onChange={e => setBuscarCaja(e.target.value)} style={{ width:'100%', padding:10, border:'1px solid #ccc', borderRadius:8, fontSize:14, marginBottom:12, boxSizing:'border-box' }} />
            <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', flexWrap:'wrap', gap:10, marginBottom:8 }}>
              <h2 style={{ fontSize:16, color:'#5c3d2e', margin:0 }}>💰 Caja del día</h2>
              <div style={{ display:'flex', gap:8, alignItems:'center' }}>
                <input type="date" value={fechaCaja} onChange={e=>{ setFechaCaja(e.target.value); cargarCaja(e.target.value); }}
                  style={{ padding:'8px 12px', border:'1px solid #ddd', borderRadius:8, fontSize:14 }} />
                <select value={filtroChoferCaja} onChange={e=>setFiltroChoferCaja(e.target.value)}
                  style={{ padding:'8px 12px', border:'1px solid #ddd', borderRadius:8, fontSize:14 }}>
                  <option value="">Todos los choferes</option>
                  {[...new Set(caja.entregas.map(e=>e.chofer_nombre))].map(ch => <option key={ch} value={ch}>{ch}</option>)}
                </select>
                <button onClick={imprimirCaja} style={{ background:'#5c3d2e', color:'#fff', border:'none', padding:'8px 14px', borderRadius:8, fontSize:13, fontWeight:600, cursor:'pointer' }}>🖨️ Imprimir</button>
              </div>
            </div>
            {caja.entregas.length === 0 ? (
              <div style={{ color:'#aaa', textAlign:'center', padding:24 }}>No hay entregas registradas hoy</div>
            ) : (
              <>
                <div style={{ overflowX:'auto', marginBottom:20 }}>
                  <table style={{ width:'100%', borderCollapse:'collapse' }}>
                    <thead><tr>
                      <th style={s.th}>Orden</th><th style={s.th}>Cliente</th><th style={s.th}>Chofer</th><th style={s.th}>Pago</th><th style={s.th}>Total</th><th style={s.th}>Acciones</th>
                    </tr></thead>
                    <tbody>
                      {caja.entregas.filter(e => {
                        if (filtroChoferCaja && e.chofer_nombre !== filtroChoferCaja) return false;
                        const b = buscarCaja.trim().toLowerCase();
                        if (!b) return true;
                        return (e.numero||'').toLowerCase().includes(b) || (e.cliente_nombre||'').toLowerCase().includes(b);
                      }).map((e,i) => (
                        <tr key={e.id} style={{ cursor:'pointer' }} onClick={()=>verOrden(e.order_id)}>
                          <td style={{ ...s.td, fontWeight:600, color:'#a0522d' }}>{e.numero}</td>
                          <td style={s.td}>{e.cliente_nombre}</td>
                          <td style={s.td}>{e.chofer_nombre}</td>
                          <td style={s.td}><span style={{ background:'#eef3ee', color:'#3a7d44', padding:'2px 8px', borderRadius:12, fontSize:11, fontWeight:600 }}>{e.metodos || '—'}</span></td>
                          <td style={{ ...s.td, fontWeight:600 }}>{fmt(e.total_orden)}</td>
                          <td style={s.td} onClick={ev=>ev.stopPropagation()}>
                            {puedeRevisar && (
                              <div style={{ display:'flex', gap:6, alignItems:'center' }}>
                                <button onClick={()=>setEditarPagoEnt(e)} title="Editar pago" style={{ background:'#fff', border:'1px solid #a0522d', color:'#a0522d', borderRadius:6, padding:'2px 8px', fontSize:12, cursor:'pointer' }}>✏️</button>
                                {e.revisado_por ? (
                                  <button onClick={()=>revisar(e.id, false)} title={"Revisado por " + (e.revisado_nombre||'')} style={{ background:'#d4f4dd', border:'none', color:'#1e7e34', borderRadius:6, padding:'2px 8px', fontSize:12, fontWeight:700, cursor:'pointer' }}>✓ {(e.revisado_nombre||'').split(' ')[0]}</button>
                                ) : (
                                  <button onClick={()=>revisar(e.id, true)} title="Marcar visto bueno" style={{ background:'#fff', border:'1px solid #1e7e34', color:'#1e7e34', borderRadius:6, padding:'2px 8px', fontSize:12, cursor:'pointer' }}>Visto bueno</button>
                                )}
                              </div>
                            )}
                            {!puedeRevisar && e.revisado_por && (
                              <span style={{ color:'#1e7e34', fontSize:12, fontWeight:700 }}>✓ {(e.revisado_nombre||'').split(' ')[0]}</span>
                            )}
                          </td>
                        </tr>
                      ))}
                      <tr style={{ background:'#f8f5f0' }}>
                        <td style={{ ...s.td, fontWeight:800 }} colSpan={5}>TOTAL DEL DÍA</td>
                        <td style={{ ...s.td, fontWeight:800, color:'#10b981', fontSize:15 }}>{fmt(caja.entregas.filter(e => !filtroChoferCaja || e.chofer_nombre === filtroChoferCaja).reduce((sum,e)=>sum+Number(e.total_orden),0))}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <h3 style={{ fontSize:14, color:'#5c3d2e' }}>Desglose por método de pago</h3>
                <div style={{ display:'flex', flexWrap:'wrap', gap:10 }}>
                  {METODOS.map(m => {
                    const total = caja.pagos.filter(p=>p.metodo===m).reduce((s,p)=>s+Number(p.total),0);
                    if (total === 0) return null;
                    return (
                      <div key={m} style={{ background:'#f8f5f0', borderRadius:8, padding:'10px 16px', minWidth:120 }}>
                        <div style={{ fontSize:12, color:'#888' }}>{m}</div>
                        <div style={{ fontSize:17, fontWeight:700, color:'#5c3d2e' }}>{fmt(total)}</div>
                      </div>
                    );
                  })}
                </div>
                <h3 style={{ fontSize:14, color:'#5c3d2e', marginTop:20 }}>Por chofer</h3>
                {[...new Set(caja.entregas.map(e=>e.chofer_nombre))].map(chofer => {
                  const delChofer = caja.entregas.filter(e=>e.chofer_nombre===chofer);
                  const totalChofer = delChofer.reduce((s,e)=>s+Number(e.total_orden),0);
                  return (
                    <div key={chofer} style={{ display:'flex', justifyContent:'space-between', padding:'8px 12px', background:'#faf7f3', borderRadius:7, marginBottom:6 }}>
                      <span><strong>{chofer}</strong> — {delChofer.length} entrega{delChofer.length!==1?'s':''}</span>
                      <span style={{ fontWeight:700, color:'#5c3d2e' }}>{fmt(totalChofer)}</span>
                    </div>
                  );
                })}
              </>
            )}
          </div>
        )}

        {/* TAB CAJA SEMANAL */}
        {!loading && tab === 'semana' && (
          <div style={s.card}>
            <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', flexWrap:'wrap', gap:10, marginBottom:12 }}>
              <h2 style={{ fontSize:16, color:'#5c3d2e', margin:0 }}>📅 Caja semanal</h2>
              <div style={{ display:'flex', gap:8, alignItems:'center', flexWrap:'wrap' }}>
                <span style={{ fontSize:13, color:'#888' }}>Desde</span>
                <input type="date" value={desde} onChange={e=>{ setDesde(e.target.value); cargarCajaSemana(e.target.value, hasta); }}
                  style={{ padding:'8px 10px', border:'1px solid #ddd', borderRadius:8, fontSize:14 }} />
                <span style={{ fontSize:13, color:'#888' }}>Hasta</span>
                <input type="date" value={hasta} onChange={e=>{ setHasta(e.target.value); cargarCajaSemana(desde, e.target.value); }}
                  style={{ padding:'8px 10px', border:'1px solid #ddd', borderRadius:8, fontSize:14 }} />
                <button onClick={imprimirSemana} style={{ background:'#5c3d2e', color:'#fff', border:'none', padding:'8px 14px', borderRadius:8, fontSize:13, fontWeight:600, cursor:'pointer' }}>🖨️ Imprimir</button>
              </div>
            </div>

            {!cajaSem || cajaSem.entregas.length === 0 ? (
              <div style={{ color:'#aaa', textAlign:'center', padding:24 }}>No hay entregas en este rango de fechas</div>
            ) : (
              <>
                {[...new Set(cajaSem.entregas.map(e=>e.dia.split('T')[0]))].sort().map(dia => {
                  const delDia = cajaSem.entregas.filter(e=>e.dia.split('T')[0]===dia);
                  const totalDia = delDia.reduce((s,e)=>s+Number(e.total_orden),0);
                  return (
                    <div key={dia} style={{ marginBottom:16 }}>
                      <h3 style={{ fontSize:14, color:'#5c3d2e', marginBottom:6 }}>{fmtFecha(dia + 'T00:00:00')}</h3>
                      <table style={{ width:'100%', borderCollapse:'collapse' }}>
                        <thead><tr>
                          <th style={s.th}>Orden</th><th style={s.th}>Cliente</th><th style={s.th}>Chofer</th><th style={s.th}>Total</th>
                        </tr></thead>
                        <tbody>
                          {delDia.map((e,i) => (
                            <tr key={i}>
                              <td style={{ ...s.td, fontWeight:600, color:'#a0522d' }}>{e.numero}</td>
                              <td style={s.td}>{e.cliente_nombre}</td>
                              <td style={s.td}>{e.chofer_nombre}</td>
                              <td style={{ ...s.td, fontWeight:600 }}>{fmt(e.total_orden)}</td>
                            </tr>
                          ))}
                          <tr style={{ background:'#f8f5f0' }}>
                            <td style={{ ...s.td, fontWeight:700 }} colSpan={3}>Total del día</td>
                            <td style={{ ...s.td, fontWeight:700 }}>{fmt(totalDia)}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  );
                })}

                <div style={{ background:'#5c3d2e', color:'#fff', borderRadius:8, padding:'14px 18px', display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:18 }}>
                  <span style={{ fontSize:15, fontWeight:700 }}>TOTAL GENERAL</span>
                  <span style={{ fontSize:20, fontWeight:800 }}>{fmt(cajaSem.entregas.reduce((s,e)=>s+Number(e.total_orden),0))}</span>
                </div>

                <h3 style={{ fontSize:14, color:'#5c3d2e' }}>Desglose por método de pago (semana)</h3>
                <div style={{ display:'flex', flexWrap:'wrap', gap:10, marginBottom:18 }}>
                  {METODOS.map(m => {
                    const total = cajaSem.pagos.filter(p=>p.metodo===m).reduce((s,p)=>s+Number(p.total),0);
                    if (total === 0) return null;
                    return (
                      <div key={m} style={{ background:'#f8f5f0', borderRadius:8, padding:'10px 16px', minWidth:120 }}>
                        <div style={{ fontSize:12, color:'#888' }}>{m}</div>
                        <div style={{ fontSize:17, fontWeight:700, color:'#5c3d2e' }}>{fmt(total)}</div>
                      </div>
                    );
                  })}
                </div>

                <h3 style={{ fontSize:14, color:'#5c3d2e' }}>Por chofer (semana)</h3>
                {[...new Set(cajaSem.entregas.map(e=>e.chofer_nombre))].map(chofer => {
                  const delChofer = cajaSem.entregas.filter(e=>e.chofer_nombre===chofer);
                  const totalChofer = delChofer.reduce((s,e)=>s+Number(e.total_orden),0);
                  return (
                    <div key={chofer} style={{ display:'flex', justifyContent:'space-between', padding:'8px 12px', background:'#faf7f3', borderRadius:7, marginBottom:6 }}>
                      <span><strong>{chofer}</strong> — {delChofer.length} entrega{delChofer.length!==1?'s':''}</span>
                      <span style={{ fontWeight:700, color:'#5c3d2e' }}>{fmt(totalChofer)}</span>
                    </div>
                  );
                })}
              </>
            )}
          </div>
        )}

      </div>
      {selected && (
        <OrderDetail
          order={selected}
          onClose={() => setSelected(null)}
          onStatusChange={() => {}}
          onOrderSaved={() => { setSelected(null); cargarTodo(); }}
        />
      )}
      {editarPagoEnt && (
        <ModalEditarPago
          data={editarPagoEnt}
          onClose={() => setEditarPagoEnt(null)}
          onDone={() => { setEditarPagoEnt(null); cargarCaja(); }}
        />
      )}
      {retiroTaller && (
        <ModalRetiroTaller
          data={retiroTaller}
          onClose={() => setRetiroTaller(null)}
          onDone={() => { setRetiroTaller(null); cargarTodo(); }}
        />
      )}
    </div>
  );
}

function ModalRetiroTaller({ data, onClose, onDone }) {
  const [metodo, setMetodo] = useState('Efectivo');
  const [monto, setMonto] = useState(String(data.total || ''));
  const [guardando, setGuardando] = useState(false);
  const METODOS = ['Efectivo', 'Tarjeta', 'SINPE', 'Deposito', 'Transferencia', 'Tasa Cero', 'Minicuotas'];
  const guardar = async () => {
    if (!monto || Number(monto) <= 0) { alert('Pone el monto'); return; }
    setGuardando(true);
    try {
      await entregaService.entregar(data.entregaId, [{ metodo, monto: Number(monto) }], 'Retiro en taller');
      alert('Retiro registrado. Entro en la caja del dia.');
      onDone();
    } catch (err) { alert(err.response?.data?.error || 'Error al registrar'); setGuardando(false); }
  };
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 200, padding: 20 }}>
      <div style={{ background: '#fff', borderRadius: 12, padding: 22, maxWidth: 400, width: '100%' }}>
        <h2 style={{ color: '#5c3d2e', marginTop: 0, fontSize: 19 }}>Retiro en Taller - {data.numero}</h2>
        <p style={{ color: '#8a7a6a', fontSize: 14 }}>Registra como pago el cliente para que entre en la caja del dia.</p>
        <label style={{ fontWeight: 600, color: '#5c3d2e' }}>Metodo de pago</label>
        <select value={metodo} onChange={e => setMetodo(e.target.value)} style={{ width: '100%', padding: 10, border: '1px solid #ccc', borderRadius: 8, fontSize: 14, marginBottom: 12, boxSizing: 'border-box' }}>
          {METODOS.map(m => <option key={m} value={m}>{m}</option>)}
        </select>
        <label style={{ fontWeight: 600, color: '#5c3d2e' }}>Monto</label>
        <input type='number' value={monto} onChange={e => setMonto(e.target.value)} style={{ width: '100%', padding: 10, border: '1px solid #ccc', borderRadius: 8, fontSize: 14, marginBottom: 16, boxSizing: 'border-box' }} />
        <div style={{ display: 'flex', gap: 8 }}>
          <button onClick={guardar} disabled={guardando} style={{ flex: 1, background: '#1e7e34', color: '#fff', border: 'none', padding: 12, borderRadius: 8, fontWeight: 700, cursor: 'pointer' }}>{guardando ? 'Guardando...' : 'Registrar y cobrar'}</button>
          <button onClick={onClose} style={{ background: '#f0ebe5', color: '#5c3d2e', border: 'none', padding: 12, borderRadius: 8, fontWeight: 600, cursor: 'pointer' }}>Cancelar</button>
        </div>
      </div>
    </div>
  );
}

function ModalEditarPago({ data, onClose, onDone }) {
  const METODOS = ['Efectivo', 'Tarjeta', 'Deposito', 'SINPE', 'Transferencia', 'Tasa Cero', 'Minicuotas'];
  const metodoInicial = (data.metodos || '').split(' + ')[0];
  const [metodo, setMetodo] = useState(METODOS.includes(metodoInicial) ? metodoInicial : 'Efectivo');
  const [monto, setMonto] = useState(String(data.total_orden || ''));
  const [guardando, setGuardando] = useState(false);
  const guardar = async () => {
    if (!monto || Number(monto) <= 0) { alert('Pone el monto'); return; }
    setGuardando(true);
    try {
      await entregaService.editarPagos(data.id, [{ metodo, monto: Number(monto) }]);
      alert('Pago actualizado');
      onDone();
    } catch (err) { alert(err.response?.data?.error || 'Error al editar el pago'); setGuardando(false); }
  };
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 200, padding: 20 }}>
      <div style={{ background: '#fff', borderRadius: 12, padding: 22, maxWidth: 400, width: '100%' }}>
        <h2 style={{ color: '#5c3d2e', marginTop: 0, fontSize: 19 }}>Editar pago - {data.numero}</h2>
        <p style={{ color: '#8a7a6a', fontSize: 14 }}>Cliente: {data.cliente_nombre}</p>
        <label style={{ fontWeight: 600, color: '#5c3d2e' }}>Metodo de pago</label>
        <select value={metodo} onChange={e => setMetodo(e.target.value)} style={{ width: '100%', padding: 10, border: '1px solid #ccc', borderRadius: 8, fontSize: 14, marginBottom: 12, boxSizing: 'border-box' }}>
          {METODOS.map(m => <option key={m} value={m}>{m}</option>)}
        </select>
        <label style={{ fontWeight: 600, color: '#5c3d2e' }}>Monto</label>
        <input type='number' value={monto} onChange={e => setMonto(e.target.value)} style={{ width: '100%', padding: 10, border: '1px solid #ccc', borderRadius: 8, fontSize: 14, marginBottom: 16, boxSizing: 'border-box' }} />
        <div style={{ display: 'flex', gap: 8 }}>
          <button onClick={guardar} disabled={guardando} style={{ flex: 1, background: '#1e7e34', color: '#fff', border: 'none', padding: 12, borderRadius: 8, fontWeight: 700, cursor: 'pointer' }}>{guardando ? 'Guardando...' : 'Guardar cambios'}</button>
          <button onClick={onClose} style={{ background: '#f0ebe5', color: '#5c3d2e', border: 'none', padding: 12, borderRadius: 8, fontWeight: 600, cursor: 'pointer' }}>Cancelar</button>
        </div>
      </div>
    </div>
  );
}
